<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

       <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="purchaseItemsList"
          item-value="id"
          item-text="description"
          :search-input.sync="itemsSearch"
          no-filter
          @input="selectItem"
          no-data-text="Nenhum Item encontrado, faça outra busca"
          :hint="purchaseItemAdditionalInfo(entry.item)"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{purchaseItemAdditionalInfo(data.item)}} </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <!-- <template v-slot:append-outer>
            <NewItemSelect
              ref="newItemSelect"
              newTitle="Adicionar Item"
              width="50%"
              openSelectButtonLabel="Adicionar Item"
              :inlineAddButton="true"
              @entry-created="itemCreated"
            />
          </template> -->
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem"
          :items="packagingsList"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >          
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.tablePriceId"
          v-bind="getObject('tablePriceId')"
          label="Tabela de preco"
          :items="extraData.accountContext.allTablePrices"
          item-value="id"
          item-text="description"
          autocomplete="off"
          :disabled="readOnly"
        >          
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="3">
        <MaskedTextField
          v-bind="getObject('value')"
          :inputData.sync="entry.value"
          mask-type="currency_10d"
          label="Valor da embalagem"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="12" md="3">
        <MaskedTextField
          v-bind="getObject('commissionPercent')"
          :inputData.sync="entry.commissionPercent"
          mask-type="13v2"
          label="Percentual de comissão"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

     

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import CultureNew from "@models/cultures/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
// import NewItemSelect from " /new_item_select.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      purchaseItemsList: [],
      purchaseItemsListLoading: false,
      itemsSearch: "",
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    CultureNew: CultureNew,   
    BaseUtil: BaseUtil,
    // NewItemSelect: NewItemSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if(this.entry.itemId){
      this.purchaseItemsList.push(this.entry.item);
      this.getPackagingOfItem();
    }
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
      
    },
    "entry.itemId": function(newValue, old){
      this.getPackagingOfItem();
    },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    selectItem: function(){
      console.log("item selecionado");
      var item = this.purchaseItemsList.filter(item => item.id = this.entry.itemId)[0]
      this.entry.item = item;
    },
    purchaseItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Compra: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '')
      }
      return info;
    },
    getPurchaseItems: function() {
      console.log("buscando");
      this.purchaseItemsListLoading = true;
      this.$apollo
        .query({
          query: ITEMS_FOR_PURCHASE_QUERY,
          variables: {
            query: this.itemsSearch
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.purchaseItemsList = response.data.accountGlobalSharedContext.allAvailableItemsSearch;
          // console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.purchaseItemsListLoading = false));
    },
    getPackagingOfItem: function() {
      this.packagingsListLoading = true;
      this.$apollo
        .query({
          query: ALL_PACKAGINGS_OF_ITEM_QUERY,
          variables: {
            itemId: this.entry.itemId,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.packagingsList = response.data.accountGlobalSharedContext.allPackagingsOfItem;
          // console.log("getPurchaseItems", this.purchaseItemsList);
        })
        .catch(response => console.log(response))
        .finally(() => (this.purchaseItemsListLoading = false));
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    cultureCreated: function(culture) {
      this.extraData.adminContext.allCultures.unshift(culture);
      this.entry.cultureId = culture.id;
      this.entry.culture = culture;
    },
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsSearch(query: $query) {
        id
        name
        description
        unit {
          name
        }
        brand {
          name
        }
        typeText
      }
    }
  }
`;

const ALL_PACKAGINGS_OF_ITEM_QUERY = gql `
  query ($itemId: ID!) {
    accountGlobalSharedContext {
      allPackagingsOfItem(itemId: $itemId) {
        id
        name
      }
    }
  }
`;
</script>

<style scoped></style>
